import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

/**
 * @typedef GetMissionsByCityQueryVars
 * @property {number} cityId Mandatory city id
 * @property {string[]} statuses Filter by status
 *
 * Get spies within a city
 */
export const getSpies = queryVars => {
  const query = `
    query (
      $cityId: ID!, 
      $first: Int, 
      $after: String, 
      $statuses: [UserStatusEnum!],
      $skip: Int
      $search: String
    ) {
      city(id: $cityId){
        spies(
          first: $first,  
          after: $after, 
          statuses: $statuses,
          skip: $skip
          search: $search
        ){
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            id
            firstName
            lastName
            status: statusV2
            memberSince
            mobilePhone
            email
            city {
              name
              id
            }
          }
        }
      }
    }
  `

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}

export const InviteSpyByEmail = inputVars => {
  const mutation = `
  mutation ($input: InviteSpyInput!){
     inviteSpy(input: $input){
        success
     }
  }`

  return callAuthorizedGraphQLEndpoint(mutation, { input: inputVars })
}
